import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "orderStep",
    serviceName: "auth",
    query: gql`
      query orderStep($ids: [String]) {
        orderStep(ids: $ids) {
          data {
            code
            title
            details
          }
        }
      }
    `,
  },
  update: {
    name: "updateOrderStep",
    serviceName: "admin",
    query: gql`
      mutation updateOrderStep(
        $ids: [String]!
        $title: String
        $code: String
        $details: String
      ) {
        updateOrderStep(
          ids: $ids
          title: $title
          code: $code
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
